import { Button } from '@onwardtravelsolutions/package-react/Components';

type SecondaryButtonProps = {
    children: React.ReactNode;
    className?: string;
} & (
    | (React.AnchorHTMLAttributes<HTMLAnchorElement> & { type?: never })
    | (React.ButtonHTMLAttributes<HTMLButtonElement> & { href?: never })
);

export default function SecondaryButton({
    children,
    className = '',
    ...rest
}: SecondaryButtonProps) {
    return (
        <Button
            className={`px-6 py-3 rounded font-semibold text-base md:text-lg inline-block transition cursor-pointer bg-secondary hover:bg-tertiary text-white ${className}`}
            {...rest}
        >
            {children}
        </Button>
    );
}
